






















































































import {functions} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes";
import { Component,Mixins,Watch } from "vue-property-decorator";
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
import ModalAlert from "@/components/ModalAlert.vue"
import ModalConfirm from "@/components/ModalConfirm.vue"
//import moment from 'moment-timezone'

//import { User } from 'firebase';

interface User {
  uid: string;
	role: string;
	accessLevel: number;
	displayName: string;
	lastName: string;
	firstName: string;
	lastNameYomigana: string;
	firstNameYomigana: string;
  disabled: boolean;
  email: string;
  emailVerified: boolean;
  hidden: boolean;
  lastSignInTime: firebase.default.firestore.Timestamp;
  updateTime: firebase.default.firestore.Timestamp;
  creationTime: firebase.default.firestore.Timestamp;
}

interface Columns{
  field: keyof User;
  order?: boolean;
}

@Component({
  components: {
    ModalAlert,
    ModalConfirm
  }
})



export default class UserList extends Mixins(Common) {
  users: User[] = []
  isLoading = false
  notice: NoticeProps = {}
  theUid = ''
  showModalConfirm = false
  showModalAlert = false
  modalConfirm = {title: 'userList.resendInvitationMail',message: 'userList.resendInvitationMailDescription', isLoading: false}
  modalAlert = {title: 'userList.error',message: 'userList.noNeedSendMailDescription'}
  orderBy: keyof User = 'creationTime'
  columns: Columns[] = [
    {
      field: 'role',
      order: true
    },
    {
      field: 'displayName',
    },
     {
      field: 'lastName',
      order: true
    },
    {
      field: 'firstName',
      order: true
    },
    {
      field: 'disabled',
      order: true
    },
    {
      field: 'email',
      order: true
    },
    {
      field: 'emailVerified',
      order: true
    },
    {
      field: 'lastSignInTime',
      order: true
    },
    {
      field: 'creationTime',
      order: true
    }
  ]
  //usersProfileImage: any = {}

  get observer(){
    return this.$refs.userListSearchFormValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  search = ''

  searchResult = ''

  searchResultsNum = 0
  
  @Watch('search')
  changeSearchText(val: string){
    let searchResultsNum = 0
    this.users = this.users.map((user) => {
      if(val.length === 0){
        user.hidden = false
        return user
      }

      if(this.$findTextByUserProfile(val, user)){
        user.hidden = false
        searchResultsNum ++
      }else{
        user.hidden = true 
      }

      return user
    })

    if(val && searchResultsNum === 0){
      this.searchResult = this.$t('userList.notFound') as string
    }else{
      this.searchResult = ''
    }
    this.searchResultsNum = searchResultsNum
  }

  async getUserAuth(){
    try{
      this.$store.commit("setLoading",true);
      this.isLoading = true
      
      const uids = this.users.map((user: User) => {
        return {uid: user.uid}
      });

      if(uids.length > 0){
        const getUsers = functions.httpsCallable('getUsers');
        const userAuthData = await getUsers({identifiers: uids, schoolId: this.$store.getters.schoolId})
        if(userAuthData.data){
          this.users = this.users.map((user: User) => {
            if(userAuthData.data[user.uid]){
              const userAuth = userAuthData.data[user.uid]
              user = {
                ...user,
                email: userAuth.email || '',
                emailVerified: userAuth.emailVerified,
              }
            }else{
              user = {
                ...user,
                emailVerified: false,
              }
            }
            return user
          })
        }
      }
    }catch(error){
      /**
       * 
       */
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  downloadCSV() {
    //console.log(this.users)
    //var csv = '\ufeff' + '品名,価格\n'
    let csv = ''
    this.users.forEach((user: User) => {
      const line = []
      line.push(user.displayName)
      line.push(user.lastName)
      line.push(user.firstName)
      line.push(user.role)
      csv += line.join(',') + '\n'
    })
    console.log(csv)
    const blob = new Blob([csv], { type: 'text/csv' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = 'Result.csv'
    link.click()
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      const usersPublicProfile = await this.$getUsersPublicProfileQuery().get()

      this.users = usersPublicProfile.docs.map((doc) => {
        const user: User = {
          displayName: '',
          lastName: '',
          firstName: '',
          lastNameYomigana: '',
          firstNameYomigana: '',
          email: '',
          ...doc.data()
          } as User

        return user
      });

      const usersPrivateProfile = await this.$getUsersPrivateProfileQuery().get()

      usersPrivateProfile.forEach((doc) => {
        const row = doc.data() as User
        this.users = this.users.map((user: User) => {
          if(user.uid === row.uid){
            return {...user,...row}
          }
          return user
        })
      });

      this.getUserAuth()
      this.sortUser()
    }catch(error){
      console.table(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  async sendInvitationMail(confirm: boolean){
    if(confirm){
      try{
        if(this.theUid !== ''){
          this.$store.commit("setLoading",true)
          this.$set(this.modalConfirm,'isLoading',true)
          
          const getUsers = functions.httpsCallable('getUsers');
      
          const userAuthData = await getUsers({identifiers: [{uid: this.theUid}], schoolId: this.$store.getters.schoolId})

          if(! userAuthData.data || Object.keys(userAuthData.data).length !== 1 || userAuthData.data[this.theUid].email === '' || userAuthData.data[this.theUid].emailVerified === true){
            throw new Error('userList.noNeedSendMail')
          }

          const sendMail = functions.httpsCallable('sendEmail');
          const data = {
            uid: this.theUid,
            schoolId: this.$store.getters.schoolId,
            actionType: 'passwordReset',
            template: 'welcomToMaritoMail'
          }

          const sentMail = await sendMail(data);

          if(sentMail.data){
            this.modalAlert.title = 'message.sent'
            this.modalAlert.message = 'userList.sentInvitationMail'
            this.showModalAlert = true
          }else{
            throw new Error('userList.unableToSendMail')
          }
        }else{
          throw new Error()
        }
      }catch(error){
        this.modalAlert.title = 'message.error'
        this.modalAlert.message = this.$getErrorMessage('',error.message)
        this.showModalAlert = true
      }finally{
        this.$set(this.modalConfirm,'isLoading',false)
        this.$store.commit("setLoading",false);
        this.isLoading = false
      }
    }
    this.showModalConfirm = false
  }


  sortUser(index = 8){
    console.log(index)
    /**
     * 名前のときよみがなで並べ替えるとかもうすこし工夫
     */
    let orderBy = this.columns[index].field
    if(orderBy == 'role'){
      orderBy = 'accessLevel'
    }

    if(orderBy == 'firstName' || orderBy == 'lastName' ){
      orderBy += 'Yomigana'
    }

    if(this.orderBy == orderBy){
      this.columns[index].order = ! this.columns[index].order
    }else{
      this.orderBy = orderBy as keyof User
    }

    this.users.sort((a, b) => {
      const nameA = a[this.orderBy] || Number.MIN_SAFE_INTEGER
      const nameB = b[this.orderBy] || Number.MIN_SAFE_INTEGER

      if(nameA === nameB){
        return 0
      }else if(this.columns[index].order && nameA > nameB){
        return 1
      }else{
        return -1
      }
    })
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
